import React from 'react';
import { Modal, Typography, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { white } from '../../../app/theme';

interface Props {
  isOpen: boolean;
  handleModalOpen: (isOpen: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontStyle: 'italic',
    color: theme.palette.secondary.main,
  },
  modal: {
    maxWidth: '35%',
    padding: '2em',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: white,
    borderRadius: 5,
    '& a': {
      color: 'inherit',
    },
  },
  notice: {
    fontSize: '1.25em',
    fontWeight: 600,
    fontStyle: 'normal',
    marginBottom: '1em',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  button: {
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '1em',
    fontStyle: 'normal',
    marginRight: '1.5em',
    '&:last-child': {
      marginRight: 0,
      marginBottom: 0,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      marginBottom: '1em',
    },
  },
}));

const VerificationModal = ({ isOpen, handleModalOpen }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Modal open={isOpen} onClose={() => handleModalOpen(false)} disableBackdropClick disableEscapeKeyDown>
      <div className={classes.modalContainer}>
        <div className={classes.modal}>
          <Typography className={classes.notice}>
            This site is intended for US-based healthcare professionals (HCPs).
          </Typography>
          <div className={classes.buttonContainer}>
            <Button
              className={classes.button}
              variant="outlined"
              color="secondary"
              onClick={() => handleModalOpen(false)}
            >
              I am a US-based HCP
            </Button>
            <Button
              className={classes.button}
              variant="outlined"
              color="secondary"
              href="https://www.blueearthdiagnostics.com/"
            >
              I am not a US-based HCP
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VerificationModal;
